import { FC, useEffect, useMemo, useState } from 'react'
import { Button } from '@/components/ui/button'
import { DocumentStatusReasonDto } from 'api/Documents/Types/DocumentStatusReasonDto'
import { Modal } from 'components/CustomModal'
import { Option, Select } from 'components/Select'

import styles from '../ClientDetailsDocument.module.scss'

interface Props {
  personalDocumentRejectionReasons: DocumentStatusReasonDto[]

  addressDocumentRejectionReasons: DocumentStatusReasonDto[]

  closeModal: () => void

  onSubmitForm: (
    personalDocumentRejectionReason?: DocumentStatusReasonDto,
    addressDocumentRejectionReason?: DocumentStatusReasonDto
  ) => void

  isPersonalDocumentSelected: boolean
  isAddressDocumentSelected: boolean
}
export const MassRejectionReasonModal: FC<Props> = ({
  onSubmitForm,
  addressDocumentRejectionReasons,
  personalDocumentRejectionReasons,
  isAddressDocumentSelected,
  isPersonalDocumentSelected,
  closeModal,
}) => {
  const handleAddressRejectionReasonChange = (value: number) => {
    setAddressDocumentRejectionReason(
      addressDocumentRejectionReasons.find((reason) => reason.id === value)
    )
  }
  const handlePersonalRejectionReasonChange = (value: number) => {
    setPersonalDocumentRejectionReason(
      personalDocumentRejectionReasons.find((reason) => reason.id === value)
    )
  }
  const [addressDocumentRejectionReason, setAddressDocumentRejectionReason] =
    useState<DocumentStatusReasonDto>()
  const [personalDocumentRejectionReason, setPersonalDocumentRejectionReason] =
    useState<DocumentStatusReasonDto>()

  const handleSubmitForm = () => {
    closeModal()
    onSubmitForm(addressDocumentRejectionReason, personalDocumentRejectionReason)
  }

  const isSubmitButtonDisabled = useMemo(
    () => !addressDocumentRejectionReason || !personalDocumentRejectionReason,
    [addressDocumentRejectionReason, personalDocumentRejectionReason]
  )

  useEffect(() => {
    setAddressDocumentRejectionReason(
      addressDocumentRejectionReasons.find((reason) => reason.isDefault)
    )
    setPersonalDocumentRejectionReason(
      personalDocumentRejectionReasons.find((reason) => reason.isDefault)
    )
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Modal visible={true} onClose={closeModal}>
      <div className={styles.container}>
        {isAddressDocumentSelected && (
          <SelectField
            name={'Address'}
            optionItems={addressDocumentRejectionReasons}
            defaultValue={addressDocumentRejectionReason}
            onChange={handleAddressRejectionReasonChange}
          />
        )}
        {isPersonalDocumentSelected && (
          <SelectField
            name='Personal'
            optionItems={personalDocumentRejectionReasons}
            onChange={handlePersonalRejectionReasonChange}
            defaultValue={personalDocumentRejectionReason}
          />
        )}
        <div className={styles.submit}>
          <Button type='button' onClick={handleSubmitForm} disabled={isSubmitButtonDisabled}>
            Submit
          </Button>
        </div>
      </div>
    </Modal>
  )
}

interface SelectProps {
  name: string
  optionItems: DocumentStatusReasonDto[]
  onChange(value: number): void
  defaultValue?: DocumentStatusReasonDto
}
const SelectField: FC<SelectProps> = ({ name, optionItems, onChange, defaultValue }) => {
  return (
    <>
      <div className={styles.field}>
        <label>Category</label>
        <div className={styles.input}>
          <label>{name}</label>
        </div>
      </div>
      <div className={styles.field}>
        <label>Rejection Reasons</label>
        <div className={styles.input}>
          <Select
            placeholder={`${name} Rejection Reason`}
            value={defaultValue?.id}
            allowClear
            showSearch
            fullWidth
            onChange={onChange}
          >
            {optionItems.map((reason) => (
              <Option value={reason.id} key={reason.id}>
                {reason.name}
              </Option>
            ))}
          </Select>
        </div>
      </div>
    </>
  )
}
